import Vue from 'vue'
import Router from 'vue-router'
import store from './store/store'

Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    scrollBehavior () {
        return { x: 0, y: 0 }
    },
    routes: [
        // FULL PAGE LAYOUTS
        {
          path: '',
          component: () => import('@/layouts/full-page/FullPage.vue'),
          children: [
          // PAGES
            {
              path: '/',
              name: 'page-login',
              component: () => import('@/views/pages/Login.vue'),
              meta: {
                checkAuth: true
              }
            },
            {
              path: '/pages/error-404',
              name: 'page-error-404',
              component: () => import('@/views/pages/Error404.vue')
            },
          ]
      },
      {
    // MAIN LAYOUT ROUTES
            path: '',
            component: () => import('./layouts/main/Main.vue'),
            children: [
        // Theme Routes
              {
                path: '/dashboard',
                name: 'home',
                component: () => import('./views/Home.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/users/splitted/:id',
                name: 'splitted-user',
                component: () => import('./views/user/UserView.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/users',
                name: 'users',
                component: () => import('./views/user/user-list/UserList.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/invoices/transactions/view/:id',
                name: 'transactions',
                component: () => import('./views/invoices/transactions/SingleView.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/invoices/transactions',
                name: 'transactions',
                component: () => import('./views/invoices/transactions/Index.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/dashboard/categories/c',
                name: 'categories-c',
                component: () => import('./views/categories/startups/Index.vue'),
                meta: {
                  requiresAuth: true
                }
              },
              {
                path: '/dashboard/categories/thematic',
                name: 'categories-thematic',
                component: () => import('./views/categories/thematics/Index.vue'),
                meta: {
                  requiresAuth: true
                }
              },
            ],
        },
        // Redirect to 404 page, if no match found
        {
            path: '*',
            redirect: '/pages/error-404'
        }
    ],
})


router.beforeEach((to, from, next) => {

  // Check if not logged in
  if(to.matched.some(record => record.meta.checkAuth)){
    if( store.state.AppActiveUser ){
      next({
        path: to.fullPath == '/' ? '/dashboard' : to.fullPath
      })
    }
    next();
  }


  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.state.isLoggedIn) {
        next({
            path: '/',
            query: { redirect: to.fullPath }
        })
    } else {
        next();
    }
  }

})



router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
    if (appLoading) {
        appLoading.style.display = "none";
    }
})


export default router
